import { useContext } from 'react';
import { MIN_LENGTH_TO_SEARCH } from 'common/constants';
import { SearchContext } from '../CardFilters/CardFilters';
import {
  getSanitizedText,
  getRegexSafeText,
} from '../../../hooks/helpers/validate-input';

export const Highlight = ({ text }: { text: string }) => {
  const searchValue = useContext(SearchContext);

  if (!searchValue || searchValue.length < MIN_LENGTH_TO_SEARCH) {
    return <span>{text}</span>;
  }
  const lowerCaseText = text.toLowerCase().trim();

  const sanitizedSearchText = getSanitizedText(searchValue);
  const escapedSearchText = getRegexSafeText(searchValue);

  const textForRegex = lowerCaseText.match(escapedSearchText)
    ? escapedSearchText
    : sanitizedSearchText;

  const parts = text.split(new RegExp(`(${textForRegex})`, 'gi'));

  return parts.map((part, i) =>
    i % 2 === 1 ? <mark key={i}>{part}</mark> : part,
  );
};
